import * as _ from 'lodash';
import Project from './project';
import type { ProjectArgs } from './project';
import type User from '../user/user';

export default class ProjectList {
  public list: Project[];

  public members: User[];

  constructor(rawDeps: (ProjectArgs | Project | any)[], members?: User[]) {
    this.list = _.map(rawDeps, (d: ProjectArgs | Project | any) => {
      // すでにProjectインスタンスの場合はそのまま返す
      if (d instanceof Project) {
        return d;
      }
      // ProjectArgsまたは任意のオブジェクトの場合は新しいProjectを作成
      return new Project(d, members);
    });
    this.members = members || [];
  }

  find(id: number | string): Project | undefined {
    return _.find(this.list, (d: Project) => d.id === parseInt(String(id), 10));
  }

  push(d: Project): number {
    return this.list.push(d);
  }

  remove(d: Project): Project[] | undefined {
    const i = this.list.indexOf(d);
    if (i > -1) {
      return this.list.splice(i, 1);
    }
    return undefined;
  }

  update(newDep: Partial<ProjectArgs> & { id: number }): Project | undefined {
    const d = this.find(newDep.id);
    if (d) {
      return _.assign(d, newDep);
    }
    return undefined;
  }
}
